/**
 * Simple bulk
 * @type {[type]}
 */
var Marionette = require('marionette')
var Backbone = require('backbone')
var App = require('app')
var _ = require('lodash')
var BulkTools = Marionette.View.extend({
  template: require('./templates/bulk-tools.html'),
  tagName: 'tr',
  templateContext: function () {
    var self = this
    // console.log(self)
    return {
      showBulkToolbar: function () {
        if (!self.options.columns) return false
        if (!self.options.columns['_bulk']) return false
        if (_.size(_.get(self.options, 'columns._bulk.options')) <= 0) return false

        if (self.collection.where({'_bulk': true}).length > 0) return true
        return false
      },
      getBulkCount: function () {
        return self.collection.where({'_bulk': true}).length
      },
      getBulkActions: function () {
        if (!self.options.columns) return false
        if (!self.options.columns['_bulk']) return false
        var actions = _.pickBy(self.options.columns['_bulk'].options, function (o) {
          return App.session.user.hasRole(o.roles)
        })

        return actions
      }
    }
  }
})

var CollectionBulkBehavior = Marionette.Behavior.extend({
  defaults: {
    // collection: false
  },
  initialize: function (options) {},
  events: {
    'click .js-apply-bulk': 'onBulkApply'
  },
  onRender: function () {
    var self = this
    this.view.showChildView('bulk_tools', new BulkTools(self.view.options))
  },
  slugify: function (text) {
    return text.toString().toLowerCase()
      .replace(/\s+/g, '-')           // Replace spaces with -
      .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
      .replace(/\-\-+/g, '-')         // Replace multiple - with single -
      .replace(/^-+/, '')             // Trim - from start of text
      .replace(/-+$/, '')            // Trim - from end of text
  },
  onBulkApply: function () {
    var bulkActionSelect = this.el.querySelector('.js-bulk-action')
    var bulkActionValue = bulkActionSelect.options[bulkActionSelect.selectedIndex].value
    if (!bulkActionValue) return console.warn('no bulk action selected')

    var actionSlug = this.slugify(bulkActionValue)
    this.view.trigger('bulk:action', {collection: this.view.options.collection, bulk_action: bulkActionValue})
    this.view.trigger('bulk:' + actionSlug, {collection: this.view.options.collection, bulk_action: bulkActionValue})
  }
})

module.exports = CollectionBulkBehavior



// WEBPACK FOOTER //
// ./js/behaviors/bulk/index.js